import { Component } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-tfg-whatsapp',
  templateUrl: './tfg-whatsapp.component.html',
  styleUrls: ['./tfg-whatsapp.component.css'],
  host: { 'class': 'ipadfooterbottom' },
  standalone: true,
  imports: [
      NgbModule
  ]
})
export class TfgWhatsappComponent {
  whatsappUrl = 'https://l.ead.me/bg8S7c';
  defaultImage = '../../assets/images/registerimg.jpg';
  responseMessage: string | null = null;

  // Example: set response message after some action
  setResponseMessage(msg: string) {
    this.responseMessage = msg;
  }
}

